import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import { escapeRegExp } from '@aytm/lib/common/func'
import { showSpellcheckerDiff, highlightSearchString } from '@aytm/app/stats/page/comments/lib/utils'

import { OEContext } from '@aytm/app/stats/page/comments'

import style from '@aytm/app/stats/page/comments/comments/styles/OEItem.module.scss'

const TextResponse = ({ node, best_span_str }) => {
  const { searchState } = useContext(OEContext)

  const { request, correctionsLevel, isHighlightSearchTerms } = searchState

  const str = useMemo(
    () => showSpellcheckerDiff(node.t, node.te || node.t, correctionsLevel, style),
    [node.t, node.te, correctionsLevel]
  )

  const content = useMemo(() => {
    let content =
      null === best_span_str ||
      2 > best_span_str?.length ||
      (0 < best_span_str?.length && new RegExp(`^${escapeRegExp(best_span_str)}([.,?!])?$`).test(node.t))
        ? str
        : str.replace(best_span_str, `<b>${best_span_str}</b>`)

    if (isHighlightSearchTerms) {
      content = highlightSearchString(content, request.query)
    }

    return content.replace(/\n/gi, '<br/>')
  }, [node.t, str, best_span_str, request, isHighlightSearchTerms])

  return (
    <div className={style['comment-answer-body']}>
      <div className={style['comment-answer-text']} dangerouslySetInnerHTML={{ __html: content }} />
      {Object.hasOwn(node, 'extra')
        ? Object.keys(node.extra).map(lang => (
            <div
              key={`comment-answer-text-${lang}`}
              className={style['comment-answer-text']}
              dangerouslySetInnerHTML={{ __html: node.extra[lang].t }}
            />
          ))
        : null}
    </div>
  )
}

TextResponse.propTypes = {
  node: PropTypes.object,
  best_span_str: PropTypes.string
}

TextResponse.displayName = 'TextResponse'

export default TextResponse
